import { CellContext, ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { AdaptiveTableCell } from '@components/common';

import { decodeHtmlEntity } from '@utils/formatter';

import { IConsistencyCheckHistoryDetail } from '@interfaces/cmModule/consistencyCheck';

const columnHelper = createColumnHelper<IConsistencyCheckHistoryDetail>();

export const getColumns = (): ColumnDef<any>[] => [
	columnHelper.accessor('paramName', {
		header: 'Parameter',
		enableSorting: true,
		cell: ({ getValue }: CellContext<IConsistencyCheckHistoryDetail, any>) => {
			return <AdaptiveTableCell text={getValue()}/>;
		},
	}),
	columnHelper.accessor('parameterValueSecond', {
		header: 'Received value',
		enableSorting: false,
		cell: ({ getValue }: CellContext<IConsistencyCheckHistoryDetail, any>) => {
			return <AdaptiveTableCell text={getValue()}/>;
		},
	}),
	columnHelper.accessor('parameterValueFirst', {
		header: 'Template value',
		enableSorting: false,
		cell: ({ getValue }: CellContext<IConsistencyCheckHistoryDetail, any>) => {
			return <AdaptiveTableCell text={getValue()}/>;
		},
	}),
	columnHelper.accessor('delta', {
		header: 'Delta',
		enableSorting: false,
		cell: ({ getValue }: CellContext<IConsistencyCheckHistoryDetail, any>) => {
			const value = getValue();
			const delta = isNaN(Number(value)) ? decodeHtmlEntity(value) : value;

			return <AdaptiveTableCell text={delta} />;
		},
	}),
	columnHelper.accessor('changedType.title', {
		header: 'Changed Type',
		enableSorting: false,
		cell: ({ getValue }: CellContext<IConsistencyCheckHistoryDetail, any>) => {
			return <AdaptiveTableCell text={getValue()}/>;
		},
	}),
];
